import { FolderKanban, ImageIcon, Laptop2, LayoutDashboard, Settings, Shield, Share2 } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

import { cn } from "@/lib/utils";

interface MobileNavProps {
  variant: "user" | "admin";
}

const userItems = [
  { href: "/app/files", label: "Drive", icon: FolderKanban },
  { href: "/app/home", label: "Home", icon: LayoutDashboard },
  { href: "/app/devices", label: "Devices", icon: Laptop2 },
  { href: "/app/photos", label: "Photos", icon: ImageIcon },
  { href: "/app/shared", label: "Shared", icon: Share2 },
  { href: "/app/settings", label: "Settings", icon: Settings },
];

const adminItems = [
  { href: "/admin", label: "Home", icon: LayoutDashboard },
  { href: "/admin/tenants", label: "Tenants", icon: FolderKanban },
  { href: "/admin/users", label: "Users", icon: Share2 },
  { href: "/admin/audit", label: "Audit", icon: Shield },
  { href: "/admin/settings", label: "Settings", icon: Settings },
];

export function MobileNav({ variant }: MobileNavProps) {
  const location = useLocation();
  const items = variant === "admin" ? adminItems : userItems;

  return (
    <nav className="fixed inset-x-0 bottom-3 z-40 px-3 lg:hidden">
      <div className="mx-auto w-full max-w-[620px] rounded-[28px] border border-border/80 bg-background-elevated/92 p-1.5 shadow-xl backdrop-blur-xl">
        <div className="flex h-16 items-stretch">
          {items.map((item) => {
            const Icon = item.icon;
            const active =
              location.pathname === item.href || location.pathname.startsWith(`${item.href}/`);

            return (
              <Link
                key={item.href}
                className={cn(
                  "relative flex flex-1 flex-col items-center justify-center gap-1 rounded-[22px] text-[10px] font-medium transition-all duration-150",
                  active
                    ? "bg-accent-subtle text-accent shadow-sm"
                    : "text-text-tertiary hover:text-text-secondary active:text-text-primary",
                )}
                to={item.href}
              >
                <span
                  className={cn(
                    "flex h-8 w-8 items-center justify-center rounded-xl transition-all duration-150",
                    active ? "bg-background-elevated" : "hover:bg-surface-hover",
                  )}
                >
                  <Icon className={cn("h-4 w-4", active && "text-accent")} />
                </span>
                <span className={cn("leading-none transition-colors", active ? "text-accent" : "text-text-tertiary")}>
                  {item.label}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
